import T from "utils/T";

const WEEK_ZONE_TYPES = [
  T('주중'),
  T('주말')
];

export default WEEK_ZONE_TYPES;